import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import RimLogin from "./RimLogin"
import { Route, BrowserRouter as Router } from "react-router-dom";


const routing = (
  <Router basename={'/rim'}>
    <div>
      <Route  path="/" component={RimLogin} />
    </div>
  </Router>
);

ReactDOM.render(routing, document.getElementById('login'));